const model = {
    name: 'ResponseContext',
    properties: {},
};
export default model;
